'use client'

import { ErrorBoundary } from '@/components/error-page/error-boundary'
import Suppliers from '@/components/page-specific/catering/suppliers'
import { useSupport } from '@/components/Providers/SupportProvider'

const SuppliersBody = () => {
  const { show } = useSupport()

  return (
    <ErrorBoundary onChatToUsClick={show}>
      <Suppliers />
    </ErrorBoundary>
  )
}

export default SuppliersBody
